import Image from "next/image"

export type Icons8IconName =
    | 'rocket' | 'shield' | 'wallet' | 'search' | 'money-bag'
    | 'lightning-bolt' | 'lock' | 'checkmark' | 'visible' | 'trending-up'
    | 'users' | 'dollar-coin' | 'fire' | 'clock' | 'document' | 'arrow-right'
    | 'check' | 'coins' | 'eye' | 'dollar' | 'star' | 'verified'
    // Fluent style icons (from MCP)
    | 'coins-fluent' | 'fire-fluent' | 'gift-fluent' | 'stack-coins'

export type Icons8IllustrationName =
    | 'wallet-connect' | 'browse-search' | 'rocket-launch' | 'claim-coins'
    | 'security-shield' | 'success-celebration'

export type Icons8SocialName = 'twitter' | 'telegram' | 'github'

interface Icons8IconProps {
    name: Icons8IconName
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
    className?: string
}

interface Icons8IllustrationProps {
    name: Icons8IllustrationName
    size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl'
    className?: string
}

interface Icons8SocialProps {
    name: Icons8SocialName
    size?: 'sm' | 'md' | 'lg'
    className?: string
}

const iconSizes = {
    xs: { width: 16, height: 16 },
    sm: { width: 20, height: 20 },
    md: { width: 24, height: 24 },
    lg: { width: 32, height: 32 },
    xl: { width: 48, height: 48 },
    '2xl': { width: 64, height: 64 },
}

const illustrationSizes = {
    sm: { width: 48, height: 48 },
    md: { width: 64, height: 64 },
    lg: { width: 80, height: 80 },
    xl: { width: 96, height: 96 },
    '2xl': { width: 128, height: 128 },
}

const socialSizes = {
    sm: { width: 20, height: 20 },
    md: { width: 24, height: 24 },
    lg: { width: 32, height: 32 },
}

export function Icons8Icon({ name, size = 'md', className = '' }: Icons8IconProps) {
    const { width, height } = iconSizes[size]

    return (
        <Image
            src={`/icons8/icons/${name}.webp`}
            alt={name}
            width={width}
            height={height}
            className={`object-contain ${className}`}
            draggable={false}
            unoptimized
        />
    )
}

export function Icons8Illustration({ name, size = 'lg', className = '' }: Icons8IllustrationProps) {
    const { width, height } = illustrationSizes[size]

    return (
        <Image
            src={`/icons8/illustrations/${name}.webp`}
            alt={name}
            width={width}
            height={height}
            className={`object-contain ${className}`}
            draggable={false}
            unoptimized
        />
    )
}

export function Icons8Social({ name, size = 'md', className = '' }: Icons8SocialProps) {
    const { width, height } = socialSizes[size]

    return (
        <Image
            src={`/icons8/social/${name}.webp`}
            alt={name}
            width={width}
            height={height}
            className={`object-contain ${className}`}
            draggable={false}
            unoptimized
        />
    )
}
